import { defineComponent, inferProps, renderSlot, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "./BootstrapButton"
import SimpleForm from "./SimpleForm"

interface Props {
	okText: string
	onClose(): void
}

const AlertForm: ReactiveComponent<Props> = (props, { slots }) => {
	return () => (
		<SimpleForm onSubmit={props.onClose}>
			{renderSlot(slots)}
			<hr />
			<div class="flex justify-end">
				<div class="flex flex-wrap items-center spacing-3">
					<BootstrapButton color="secondary" type="submit">
						{props.okText}
					</BootstrapButton>
				</div>
			</div>
		</SimpleForm>
	)
}

export default defineComponent(AlertForm, inferProps<Props>())
